<template>
  <v-container fluid style="position: relative;">
    <v-layout row wrap>
      <v-flex xs12 sm8 offset-sm2 md6 offset-md3 lg4 offset-lg4 mt-3 class="box650">
        <v-form v-model="valid" @submit.prevent="userSignInCall({ email, password })">
          <v-flex xs12 class="text-xs-center" mt-2 @click="setFocus">
            <h2>{{$t('init_with_email')}}</h2>
            <v-layout column>

              <v-flex>
                <v-alert type="error" dismissible v-if="error" v-model="alert">
                  {{ $t(error) }}
                </v-alert>
              </v-flex>

              <v-flex>
                <v-text-field
                  name="email"
                  :label="$t('email')"
                  id="email"
                  type="email"
                  v-model="email"
                  autofocus
                  autocomplete="email"
                  :placeholder="$t('email')"
                  :rules="[rules.fieldRequired, rules.email]"
                  required></v-text-field>
              </v-flex>

              <v-flex>
                <v-text-field
                  name="password"
                  :label="$t('password')"
                  id="password"
                  type="password"
                  v-model="password"
                  autocomplete="current-password"
                  :rules="[rules.fieldRequired, rules.min6]"
                  required></v-text-field>
              </v-flex>

              <v-btn
                color="primary"
                type="submit"
                :disabled="!valid || isLoading"
                :loading="isLoading">{{$t('continue')}}</v-btn>

              <v-flex xs12 class="text-xs-center" mt-5>
                <v-btn flat to="/reset_password">{{$t('reset_password')}}</v-btn>
              </v-flex>
              <!-- <v-flex xs12 class="text-xs-center" mt-5>
                <v-btn flat to="/signup">{{$t('no_account')}}</v-btn>
              </v-flex>
 -->
            </v-layout>
          </v-flex>
        </v-form>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapActions, mapMutations } from 'vuex'
import firebase from 'firebase/app'
import google from '@/assets/google.svg'
import facebook from '@/assets/facebook.svg'
import email from '@/assets/email.svg'
import rules from '@/utils/rules'

export default {
  data () {
    return {
      valid: false,
      active: true,
      email: '',
      password: '',
      alert: false,
      isLoading: false,
      privacy: null,
      terms: null,
      focused: null,
      google,
      facebook,
      email: '',
      rules,
      social: true,
    }
  },
  methods: {
    ...mapActions(['userSignIn', 'userSignInProvider']),
    ...mapMutations(['setEmail', 'setSignup']),
    async userSignInCall(payload) {
      this.isLoading = true
      const res = await this.userSignIn({...payload, email: this.email})
      if (!(res.sucess && res.uid)) {
        this.$store.commit('setError', 'Error de credenciales')
      }
      this.isLoading = false
    },
    setFocus () {
      this.focused = true
    }
  },
  computed: {
    error () {
      return this.$store.state.error
    }
  },
  watch: {
    error (value) {
      if (value) {
        this.isLoading = false
        this.alert = true
      }
    },
    alert (value) {
      if (!value) {
        this.$store.commit('setError', null)
      }
    }
  },
  activated () {
    this.email = this.$store.getters.email
    this.$store.commit('setError', null)
    if (this.$route.query.from === 'landing') {
      window.gtag('event', 'conversion', {'send_to': 'AW-743809320/QFNRCPPg5Z0BEKjC1uIC'})
    } else {
      window.gtag('event', 'conversion', {'send_to': 'AW-743809320/IEyXCJLl5Z0BEKjC1uIC'})
    }

    if (this.$route.path !== '/signin') {
      window.adperf_conversion(284);
    }
  }
}
</script>
<style scoped>
  .navidad:not(.active) {
    opacity: 0;
    z-index: 0;
  }
  .fetivales-logo.navidad {
    display: none;
  }
  .navidad {
    transition: opacity 1s;
    opacity: 1;
    position: relative;
    width: 100%;
    top: 0;
    left: 0;
    padding: 10px;
    /*z-index: 9999;*/
    object-fit: cover;
    object-position: right 15%;
    max-height: 700px;
  }
  .error-font {
    color: red;
    font-size: 13px;
  }
  .ph-label {
    color: rgba(0,0,0,0.54);
    font-size: 16px;
  }
  .google img {
    width: 20px;
  }
  .facebook img {
    width: 22px;
  }
  .email img {
    width: 22px;
    filter: brightness(0) invert(1);
  }
  .google img, .facebook img, .email img {
    margin: 0 10px;
  }

  .theme--light.v-icon {
    color: white;
  }
</style>
<style>

   .theme--light.v-text-field > .v-input__control > .v-input__slot:before {
    border-color: #f2613f!important;
  }

  .theme--light.v-label {
    color: white;
  }

  .theme--light.v-input:not(.v-input--is-disabled) input, .theme--light.v-input:not(.v-input--is-disabled) textarea {
    color: white;
  }


  .theme--light.v-btn {
    color: white;
  }

.theme--light.application {
  background: black;
  color: white;
}
  @media only screen and (max-width: 370px) {
    .molins img {
      width: 100%
    }
  }
  @media only screen and (max-width: 530px) {
    .sitges img {
      width: 100%
    }
  }
  .v-content__wrap {
    overflow: scroll;
  }
</style>
